import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-auth" }
const _hoisted_3 = { class: "tag-state lg rounded-50 flex align-items-center gap-4 px-4 py-4 mb-6" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "px-3" }
const _hoisted_6 = { class: "my-1" }
const _hoisted_7 = { class: "text-sm text-grey-600" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PinInput = _resolveComponent("PinInput")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.userPhoto || '/public/assets/users/300w/user2.jpg',
          class: "rounded-100 overflow-hidden size-2xl",
          alt: "Photo de profil"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.userName), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userEmail) + " | " + _toDisplayString(_ctx.userCollectivite), 1)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "rounded-100 overflow-hidden size-2xl ml-auto" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-coop-finance.svg",
            width: "100%",
            alt: "Coop Finance"
          })
        ], -1))
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "font-semibold text-center mt-6 mb-5" }, "Créer votre code de sécurité", -1)),
      _createElementVNode("form", {
        class: "form",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_PinInput, {
          modelValue: _ctx.securityCode,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.securityCode) = $event)),
          "input-id": "security-code",
          length: 4,
          onComplete: _ctx.handlePinComplete
        }, null, 8, ["modelValue", "onComplete"]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn lg w-100 flex-center mt-5",
          disabled: !_ctx.isCodeComplete || _ctx.isSubmitting
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            src: "/public/icons/icon-valider.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Validation...' : 'Valider'), 1)
        ], 8, _hoisted_8)
      ], 32),
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-read text-grey-600 text-center mt-5" }, " Votre code de sécurité sera utilisé pour vous permettre d'accéder à votre compte. ", -1))
    ])
  ]))
}